module.exports = __webpack_public_path__ + "static/media/lose.1cd6671d.png";